import { render, staticRenderFns } from "./Settings-Parcours.vue?vue&type=template&id=096e0bb2&scoped=true&"
import script from "./Settings-Parcours.vue?vue&type=script&lang=js&"
export * from "./Settings-Parcours.vue?vue&type=script&lang=js&"
import style0 from "./Settings-Parcours.vue?vue&type=style&index=0&id=096e0bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e0bb2",
  null
  
)

export default component.exports